import angular from 'angular';
import _ from 'underscore';

function Ctrl($scope, $rootScope, $timeout, jsSdkUser, utilsService) {
  $scope.completeProfileSubmitting = null;
  $scope.completeProfileResult = null;
  $scope.completeProfileBtnOptions = {
    buttonDefaultText: 'UPDATE PROFILE',
    buttonSubmittingText: 'Updating profile....',
    buttonSuccessText: 'SUCCESS!',
    buttonErrorText: 'Error updating profile.',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonSuccessClass: 'btn-success',
    buttonErrorClass: 'btn-danger'
  };

  $scope.user = jsSdkUser.getCurrentUser();

  if (!$scope.user) {
    $scope.callback(null);

    return;
  }

  $scope.requiredKeys = [];

  angular.forEach($scope.config.keysToVerify, function(value) {
    $scope.requiredKeys[value] = true;
  });

  $scope.submit = function() {
    $scope.completeProfileSubmitting = true;

    const user = _.pick($scope.user, $scope.config.keysToVerify);

    updateUser(user);
  };

  $scope.closeAlert = function() {
    $scope.errorMsg = null;
  };

  const updateUser = function(user) {
    // Update a user's information
    jsSdkUser.updateMe(user).then(function success(resp) {

      // Done
      $scope.completeProfileResult = 'success';

      // Broadcast event
      $rootScope.$broadcast('userUpdated');

      // Successfully completed profile
      $scope.callback(resp);

    }, function error(resp) {

      // Error
      $scope.error(resp);
    });
  };

  $scope.error = function(response) {
    $scope.errorMsg = utilsService.errorMessage(response);
    $scope.completeProfileResult = false;
    $scope.completeProfileSubmitting = false;
    $scope.completeProfileResult = 'error';
  };
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$timeout',
  'jsSdk.user',
  'utilsService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/completeProfile/controller.js